import React from 'react';
import { LessonComment } from 'types';
import FormattedDate from 'components/FormattedDate/FormattedDate';
import LessonCommentEditor from 'components/LessonComments/LessonCommentEditor';

interface LessonCommentItemProps {
  comment: LessonComment;
  isAuthor: boolean;
  canAccessLessons: boolean;
  isEditing: boolean;
  isSaving: boolean;
  isDeleting: boolean;
  onStartEdit: () => void;
  onCancelEdit: () => void;
  onSaveEdit: (content: string) => void;
  onRequestDelete: () => void;
}

const getInitials = (name: string) =>
  name.split(' ').map((n) => n[0]).join('').slice(0, 2).toUpperCase();

const LessonCommentItem: React.FC<LessonCommentItemProps> = ({
  comment,
  isAuthor,
  canAccessLessons,
  isEditing,
  isSaving,
  isDeleting,
  onStartEdit,
  onCancelEdit,
  onSaveEdit,
  onRequestDelete,
}) => (
  <div className="p-4 rounded-lg bg-gray-50">
    <div className="flex items-start gap-3">
      <div className="flex-shrink-0 w-8 h-8 bg-terracota rounded-full flex items-center justify-center">
        {comment.author.avatar ? (
          <img className="w-[32px] h-[32px] rounded-full object-cover" alt="Imagem de perfil" src={comment.author.avatar} />
        ) : (
          <span className="text-white text-xs font-semibold">{getInitials(comment.author.name)}</span>
        )}
      </div>

      <div className="flex-1">
        <div className="flex flex-wrap items-center gap-2 mb-1">
          <span className="text-sm font-medium text-gray-900">{comment.author.name}</span>
          <span className="text-gray-400">•</span>
          <span className="text-gray-900 text-xs">
            <FormattedDate date={comment.createdAt} />
          </span>
        </div>

        {isEditing ? (
          <LessonCommentEditor
            initialContent={comment.content}
            saving={isSaving}
            onSave={onSaveEdit}
            onCancel={onCancelEdit}
          />
        ) : (
          <p className="text-gray-700 text-sm leading-relaxed">{comment.content}</p>
        )}

        {isAuthor && canAccessLessons && !isEditing && (
          <div className="flex items-center gap-4 mt-2">
            <button
              onClick={onStartEdit}
              disabled={isDeleting}
              className="text-xs text-gray-500 hover:underline disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Editar
            </button>
            <button
              onClick={onRequestDelete}
              disabled={isDeleting}
              className="text-xs text-red-500 hover:underline disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isDeleting ? 'Excluindo...' : 'Excluir'}
            </button>
          </div>
        )}
      </div>
    </div>
  </div>
);

export default LessonCommentItem;
